import React from 'react';
import JungjinMap from './JungjinMap.js'
import JCoupMap from './JcoupMap.js'
import { NavMenu } from './../NavMenu.js'
import '../Shared/Css/jcMap.css'

function JCMap() {
  return (
    <>
      <NavMenu />
      <div className='jcmap-container'>
        <div className='jcmap-item'>
          <JungjinMap></JungjinMap>
        </div>
        <div className='jcmap-item' >
          <JCoupMap></JCoupMap>
        </div>

      </div>
    </>
  );
}

export default JCMap;